import type { EmailEventRead } from '#/shared/api/generated/communication/models'
import { useGetEmailEventsApiV1EmailMessagesEmailIdEventsGet } from '#/shared/api/generated/communication/theCargoCommunication'

export interface UseEmailEventsResult {
  events: EmailEventRead[]
  isLoading: boolean
  isError: boolean
}

/** SendGrid event trail for one email; fetched lazily — `enabled` is the
 *  hover-card's open state, so nothing fires until the user hovers the tick. */
export function useEmailEvents(
  emailId: string,
  enabled: boolean,
): UseEmailEventsResult {
  const query = useGetEmailEventsApiV1EmailMessagesEmailIdEventsGet(emailId, {
    query: { enabled: enabled && Boolean(emailId) },
  })

  const events = query.data?.data ?? []
  return {
    events: [...events].sort((a, b) => a.at.localeCompare(b.at)),
    isLoading: query.isLoading,
    isError: query.isError,
  }
}
